import {
    RecordSearchService
} from "@/common/api.service";
import {
    SEARCH,
    SEARCH_PAGE_NEXT,
    SEARCH_PAGE_PREV,
    VIEW_END_LOADING,
    VIEW_START_LOADING
} from "./actions.type"

const initialState = {
    available_facets: [
        "collections",
        "keywords",
        "education_levels",
        "subjects",
        "hr_themes",
        "topics",
    ],
    available_filters: [
        "formats",
        "languages"
    ],
    nextPage: null,
    previousPage: null,
    results: [],
    results_cmhr: [],
    resultsCount: 0,
    resultsFacets: {},
    selected_facets: [],
    selectedFilters: {
        "formats": null,
        "languages": null
    }
}

export const state = { ...initialState };

export const actions = {
    async[SEARCH](context, query) {
        this.dispatch(VIEW_START_LOADING);
        context.commit("StateSet", query);
        const { data } = await RecordSearchService.search(
            document.documentElement.lang,
            query,
            context.state.available_facets,
            context.state.available_filters);
        context.commit("SearchResultsSet", data);
        this.dispatch(VIEW_END_LOADING);
        return data;
    },
    async[SEARCH_PAGE_NEXT](context) {
        this.dispatch(VIEW_START_LOADING);
        const { data } = await RecordSearchService.searchNextPrev(state.nextPage);
        context.commit("SearchResultsSet", data);
        this.dispatch(VIEW_END_LOADING);
        return data;
    },
    async[SEARCH_PAGE_PREV](context) {
        this.dispatch(VIEW_START_LOADING);
        const { data } = await RecordSearchService.searchNextPrev(state.previousPage);
        context.commit("SearchResultsSet", data);
        this.dispatch(VIEW_END_LOADING);
        return data;
    }
};

export const mutations = {
    StateSet(state, route) {
        if(route == null) {
            state.selected_facets = [];
            for (let i=0; i < state.available_filters.length; i++) {
                state.selectedFilters[state.available_filters[i]] = null;
            }
            return;
        }

        // Update Facets
        let facets = [];
        for (let i=0; i < state.available_facets.length; i++) {
            let group = state.available_facets[i];
            if(route[group]) {
                if(route[group] instanceof Array) {
                    for(let i = 0; i < route[group].length; i++) {
                        facets.push({
                            'category': group,
                            'facet': route[group][i]
                        });
                    }
                } else {
                    facets.push({
                        'category': group,
                        'facet': route[group]
                    });
                }
            }
        }
        state.selected_facets = facets;

        // Update Filters
        for (let i=0; i < state.available_filters.length; i++) {
            const group = state.available_filters[i];
            if(route[group]) {
                if(route[group] instanceof Array) {
                    state.selectedFilters[group] = route[group][0];
                } else {
                    state.selectedFilters[group] = route[group];
                }
            } else {
                state.selectedFilters[group] = null;
            }
        }
    },
    SearchResultsSet(state, r) {
        let i = 0;
        const max_cmhr = 5
        const boostedResults = [];
        state.results_cmhr = r.results.filter(result => {
            if (result.badge == "CMHR resource") i++
            let boostResult = (result.badge == "CMHR resource" || result.badge == "Ressource du MCDP") && i <= max_cmhr

            if (boostResult) boostedResults.push(result.id);
            return boostResult;
        })
        state.results = r.results.filter(result => {
            return !boostedResults.includes(result.id)
        })
        state.resultsCount = r.count;

        const nextPath = r.next ? r.next.slice(r.next.match(/v1/).index + 3) : null;
        const prevPath = r.previous ? r.previous.slice(r.previous.match(/v1/).index + 3) : null;

        state.nextPage = nextPath;
        state.previousPage = prevPath;

        var facets = {}
        for (var key in r.facets) {
            var f = r.facets[key];
            var k = key.replace("_filter_", "");
            facets[k] = f[k].buckets;
        }
        state.resultsFacets = facets;
    },
};

const getters = {
    searchFacets(state) {
        return state.resultsFacets;
    },
    searchAvailableFacets(state) {
        return state.available_facets;
    },
    searchAvailableFilters(state) {
        return state.available_filters;
    },
    searchResults(state) {
        return state.results;
    },
    searchResultsCmhr(state) {
        return state.results_cmhr;
    },
    searchNextPage(state) {
        return state.nextPage;
    },
    searchPreviousPage(state) {
        return state.previousPage;
    },
    searchSelectedFacets(state) {
        return state.selected_facets;
    },
    searchSelectedFilters(state) {
        return state.selectedFilters;
    },
    resultsCount(state) {
        return state.resultsCount;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
